import { FC, ComponentPropsWithoutRef } from 'react';
import { css } from '@emotion/react';
import { Spinner } from '@chakra-ui/react';
import { colors, fontStyles, spacing } from '../../styles';
import arrowForward from './arrowForward.svg';

interface Props extends ComponentPropsWithoutRef<'button'> {
  isLoading?: boolean;
  hideChevron?: boolean;
}

const RowButton: FC<Props> = ({ children, isLoading, hideChevron, ...props }) => {
  return (
    <button
      css={css`
        display: block;
        width: 100%;
        background-color: transparent;
        border: none;
        padding: ${spacing.centi} 0;
        text-align: left;
        ${fontStyles.cat}
        color: ${colors.petrolBlue};
        html[data-theme='dark'] & {
          background-color: ${colors.liquorice};
          color: ${colors.skyBlue};
        }
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      `}
      {...props}
    >
      {children}
      {isLoading ? (
        <span
          css={css`
            vertical-align: middle;
            float: right;
          `}
        >
          <Spinner size="sm" color={colors.cloud} />
        </span>
      ) : !hideChevron ? (
        <img
          src={arrowForward}
          css={css`
            vertical-align: middle;
            float: right;
          `}
        />
      ) : null}
    </button>
  );
};

export default RowButton;
